import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, catchError, map, Observable, of, switchMap, tap } from 'rxjs';
import { AccountsService } from '../../../accounts.service';
import { Backup } from '../../../core/backup';
import { Site, SiteService } from '../../../core/site';
import { AdvancedSiteSettingsApiService, GetSubscribedCountResponse } from '@vendasta/wsp-wp-manager';

@Component({
  selector: 'app-restore-confirmation-dialog',
  templateUrl: './restore.component.html',
  styleUrls: [`./restore.styles.scss`],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RestoreConfirmationDialogComponent {
  public backup: Backup;
  isStagingBackup = false;
  isExpress$: Observable<boolean> = of(true);
  siteEdition$: Observable<string> = of('');
  subsitesCount$: Observable<number> = of(0);
  isLoadingSubsitesCount$ = new BehaviorSubject<boolean>(true);

  constructor(
    public dialogRef: MatDialogRef<RestoreConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountsService: AccountsService,
    private siteService: SiteService,
    private advancedSiteSettingsApiService: AdvancedSiteSettingsApiService,
  ) {
    this.backup = data.backup;
    this.isStagingBackup = data.isStagingBackup;
    this.isExpress$ = this.accountsService.isExpress$;
    this.siteEdition$ = this.accountsService.editionName$;

    this.siteService.get().pipe(
      switchMap((site: Site) => this.advancedSiteSettingsApiService.getSubscribedCount({ siteId: site.siteId }).pipe(
        map((response: GetSubscribedCountResponse) => response.subscribedCount),
      )
    ),
    tap((count: number) => {
      this.subsitesCount$ = of(count);
      this.isLoadingSubsitesCount$.next(false);
    }),
    catchError((error: any) => {
      this.isLoadingSubsitesCount$.next(false);
      console.error('Error getting subscribed count:', error);
      return of(0);
    })
  ).subscribe();
  }

  getEnv(): string {
    return this.isStagingBackup ? 'PAGES.BACKUPS.TABS.STAGING' : 'PAGES.BACKUPS.TABS.PRODUCTION';
  }

  getPrimaryBtnText(): string {
    return this.isStagingBackup
      ? 'PAGES.BACKUPS.RESTORE_MODAL.BUTTONS.RESTORE_TO_STAGING'
      : 'PAGES.BACKUPS.RESTORE_MODAL.BUTTONS.RESTORE_TO_PRODUCTION';
  }

  getSecondaryBtnText(): string {
    return this.isStagingBackup
      ? 'PAGES.BACKUPS.RESTORE_MODAL.BUTTONS.RESTORE_TO_PRODUCTION'
      : 'PAGES.BACKUPS.RESTORE_MODAL.BUTTONS.RESTORE_TO_STAGING';
  }
}
